export class PermissionHierarchy {
    securityRoleId?: string;
    name?: string;
    securityRolePermissions: SecurityRolePermissions;
    editedDate?: string;
    isDerivedFromTemplate?: boolean;
    isMandatory?: boolean;
    isSysAdmin?: boolean;
}

export class SecurityRolePermissions {
    securityPermissionRowId?: string;
    name?: string;
    actions?: PermissionActions[];
    children?: SecurityRolePermissions[];
}

export class PermissionActions {
    securityRolePermissionId: string;
    allowed: boolean;
    securityPermissionId: string;
    securityPermissionColumn: SecurityPermissionColumn;

    constructor(securityRolePermissionId: string, allowed: boolean, securityPermissionId: string, securityPermissionColumn: SecurityPermissionColumn) {
        this.securityRolePermissionId = securityRolePermissionId;
        this.allowed = allowed;
        this.securityPermissionId = securityPermissionId;
    }
}

export class SecurityPermissionColumn {
    securityPermissionColumnId: string;
    name: string;
}

export class SecuRityRolesTemplate {
    editedDate: string;
    isDerivedFromTemplate: boolean;
    isMandatory: boolean;
    isSysAdmin: boolean;
    name: string;
    securityRoleId: string;
}

export class DeleteSecurityRole {
    securityRoleId: string;
    active: boolean;
}
